module.exports = __webpack_public_path__ + "img/bitbox02-welcome.de769c08.png";